

import styles from "./sbgamePage.module.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ImgBuilder from "../../assets/ImgBuilder";
import { useUserData } from "../../functions/updateUserData";
import { useTranslation } from "react-i18next";

const SbGamePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [modeChosen, setModeChosen] = useState(null);
  const [modeChosenActivated, setModeChosenActivated] = useState("");

  const gameModes = t("mode_selection.game_modes", { returnObjects: true });

  const { setUserData } = useUserData();

  const DELAY = 350;

  const activateGameModes = {
    factChecker: () => {
      setUserData((prev) => ({ ...prev, userTraceID: -2 }));
      setTimeout(() => navigate("/settings"), DELAY);
      // setTimeout(() => navigate("/social/truth-seeker"), DELAY);
    },
    chaosMode: () => {
      setUserData((prev) => ({ ...prev, userTraceID: -3 }));
      setTimeout(() => navigate("/settings"), DELAY);
      // setTimeout(() => navigate("/social/chaos"), DELAY);
    },
  };

  const handleClick = (gameType) => {
    if (activateGameModes[gameType]) {
      setModeChosenActivated(styles.disappearBox);
      activateGameModes[gameType]();
    } else {
      console.error("Unknown game type:", gameType);
    }
  };

  // // give to one class "choosen" and to the other "notChoosen"
  // const getClassName = (choice) => {
  //   if (modeChosen === null) {
  //     // No class if none is chosen
  //     return ''; 
  //   }
  //   if (modeChosen === choice) {
  //     return styles.modeChosen; // Class for the active choice
  //   }
  //   return styles.modeChosenNot; // Class for the other choice
  // };

  const modeDictionary = gameModes.reduce((acc, item) => {
    acc[item.mode] = {
      name: item.name,
      description: item.description,
      button: item.button,
    };
    return acc;
  }, {});

  const chooseMode = (choice) => {
    setModeChosen((prev) => (prev === choice ? null : choice));
  };

  // // keyboard support for the PNGs
  // const onKeyActivate = (ev, choice) => {
  //   if (ev.key === "Enter" || ev.key === " ") {
  //     ev.preventDefault();
  //     chooseMode(choice);
  //   }
  // };

  return (
    <div className={styles.wrapper}>
      {/* Background + headline PNGs (originals remain) */}
      <img alt="modeSelectorImages" src={ImgBuilder.modeSelectorBg} className={styles.bgImageModeSeletor} aria-hidden />

      {/* HEADER IMAGES with animation (added headerLayer + delays only) */}
      <img
        src={ImgBuilder.headerGame}
        className={`${styles.bgImageModeSeletor} ${styles.headerLayer}`}
        style={{ "--hdelay": "0ms" }}
        alt=""
        aria-hidden
      />
      <img
        src={ImgBuilder.headerOn}
        className={`${styles.bgImageModeSeletor} ${styles.headerLayer} ${styles.headerGlow}`}
        style={{ "--hdelay": "800ms" }}  /* increase/decrease to change gap */
        alt=""
        aria-hidden
      />

      {/* Two clickable pop-up PNGs sized/positioned together */}
      {/* <div className={styles.modePinsOverHero}>
        <div className={`${styles.pinWrap} ${styles.pinTruth}`} style={{ "--delay": "1800ms" }}>
          <img
            src={ImgBuilder.truth_seeker}
            alt={modeDictionary?.factChecker?.name || "Truth Seeker"}
            className={styles.pinImg}
            draggable="false"
          />
        </div>

        <div className={`${styles.pinWrap} ${styles.pinChaos}`} style={{ "--delay": "1800ms" }}>
          <img
            src={ImgBuilder.chaosModeAsset}
            alt={modeDictionary?.chaosMode?.name || "Chaos Mode"}
            className={styles.pinImg}
            draggable="false"
          />
        </div>

      </div> */}

      <div className={`${styles.boxModeSelector} ${modeChosenActivated}`} style={{ "--hdelay": "1600ms" }}>
        <p className={styles.callToActionBox}>
          {t("mode_selection.title")}
        </p>
        <p className={styles.subCallToActionBox}>
          {t("mode_selection.subtitle")}
        </p>
        <div className={styles.gameModesContainer}>
          {gameModes.map((item, idx) =>
            <div key={idx} onClick={() => chooseMode(item.mode)} className={`${styles.optionGame} ${item.mode === modeChosen ? styles.activeMode : ""}`}>
              <div className={`${styles.circleSelected}`}></div>
              <img alt="optionGame" className={styles.imageOptionGame} src={ImgBuilder[item.asset]}/>
              <p className={styles.textOptionGame}>{item.name}</p>
            </div>
          )}
        </div>
        
        {(modeChosen !== null) && 
          <div className={styles.explanationBox}>
            <p className={styles.confirmationExplanationBox}>
              {t("mode_selection.confirmation")}{" "}
              <b>
                {modeDictionary[modeChosen].name}
              </b>
            </p>
            <div className={styles.lowerExplanationBox}>
              <p className={styles.textExplanationBox}>
                {modeDictionary[modeChosen].description}
              </p>
              <button onClick={() => handleClick(modeChosen)} className={styles.buttonExplanationBox}>
                {modeDictionary[modeChosen].button}
              </button>
            </div>
            
          </div>
        }
        

      </div>


      
    </div>
  );
};

export default SbGamePage;
